var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.881,
    height: 19.764,
    viewBox: "0 0 11.881 19.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smartphone",
    transform: "translate(-89.856)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(89.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M99.266,0h-6.94a2.463,2.463,0,0,0-2.47,2.47V17.293a2.478,2.478,0,0,0,2.47,2.47h6.94a2.463,2.463,0,0,0,2.47-2.47V2.47A2.463,2.463,0,0,0,99.266,0ZM95.808,18.169a1.123,1.123,0,1,1,1.123-1.123A1.112,1.112,0,0,1,95.808,18.169Zm4.806-3.436H90.979V3.3h9.635Z",
    transform: "translate(-89.856)",
    fill: "#072430"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.c855116172974a1bc33beb0b3aa098c1.svg";
export { ForwardRef as ReactComponent };